import React, { useState } from "react";
import { object, string } from "yup";
import { CompetitionController, PayoutController } from "../../../controllers";
import constant from "../../../utils/constant";
import { MimaToastUtil } from "../../../components";
import { CreateVotes, UpdateParticipants } from "../../../pages";

const CreateVotesContainer = ({ closeModal, selectedParticipant }) => {
  const [loading, setLoading] = useState(false);
  const validationSchema = () => {
    return object({
      votes: string().required("Enter number of votes"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      participant: selectedParticipant._id,
      competition: selectedParticipant.competition._id,
      fullname: `${selectedParticipant.firstname} ${selectedParticipant.lastname}`,
      votes: values.votes,
    };

    const { status, errorMessage } =
      await CompetitionController.createVotes(payload);
    setLoading(false);
    if (status === constant.Success) {
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    MimaToastUtil.error({
      message: errorMessage,
    });

    return closeModal();
  };

  return (
    <CreateVotes
      closeModal={closeModal}
      validationSchem={validationSchema}
      loading={loading}
      onSubmit={onSubmit}
      selectedParticipant={selectedParticipant}
    />
  );
};

export default CreateVotesContainer;
